import React, {useEffect, useState} from "react";
import {
  Page,
} from "components/common";
import { FormGroup } from "components/common/Forms";
import GetBack from "components/refactoring/BackButton";
import { LocalForm, Control, actions } from "react-redux-form";
import { Trans } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button, TabContent, Table, TabPane, Col, Row, NavLink, Nav, NavItem, Card, Modal, ModalFooter, ModalHeader, ModalBody } from "reactstrap";
import { ApiClient } from "services";
import { KeyField } from "pages/Applications/Zatca/ZatcaDetails";
import { NotificationManager } from "react-notifications";
import { formatDateTime, navTab } from "services/util";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Select from "react-select";
import { snakeToTitle } from "Helpers";
import DatePicker from "components/common/Forms/DatePicker";
import { HistoryAndNotes } from "components";

export const getOutlineStyle = (color, size) => ({
    border: `2px solid ${color}`,
    color: color,
    padding: '0.25rem 0.5rem',
    borderRadius: '0.2rem',
    fontSize: size
  });

export const OrganisationDetail = ({
  t,
  match,
  history,
}) => {

    const client = ApiClient() 
    const classnames = (...classNames) => classNames.filter(Boolean).join(' ');


    const [orgData, setorganisationData] = useState();
    const [loading, setLoading] = useState(false);
    const [allPlans, setPlans] = useState();
    const [isUpgrade, setisOpen] = useState(false);
    
    const fetchData = async () => {
        try {
          setLoading(true)
          const responseOrg = await client.get(`core/organisation/${match.params.id}`);
          const orgdata = responseOrg.data;
          setorganisationData(orgdata);
          setLoading(false)
        //   if (!orgdata.subscription_detail.current_subscription.id) {
            const response = (await client.get(`subscription-plans`)).data;
            setPlans(response)
        //   }
        } catch (error) {
          console.error("Error fetching data:", error);
          setLoading(false)
        }
      };

    useEffect(() => {
    
      fetchData();
    }, []);

  const [isGenerating, setIsGenerating] = useState();
  
  const [activeTab, setActiveTab] = useState('1');
  
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };    

  const status_map = {
    'Paid':{'color':'#72B566', text:t('Paid')},
    'Unpaid':{'color':'#ffc107', text:t('Unpaid')},
    'Cancelled':{'color':'#dc3545', text:t('Cancelled')}
  }

  const moduleData = orgData?.subscription_detail?.current_subscription?.subscribed_features?.filter(item => item.content_type_name === "hesaabmodule")
  const appData = orgData?.subscription_detail?.current_subscription?.subscribed_features?.filter(item => item.content_type_name === "hesaabapplication")
  const langData = orgData?.subscription_detail?.current_subscription?.subscribed_features?.filter(item => item.content_type_name === "hesaablanguage")

  const handlePost = async (values) => {

    setIsGenerating(true);

    client.post(`/core/organisation-client-id`, values)
      .then(response => {
          setTimeout(() => {
            NotificationManager.success(t('Generate client code Successfully.'));
            setIsGenerating(false);
            fetchData()
          }, 1500)
      })
      .catch(error => {
        if (error.response && error.response.data) {
          const errors = error.response.data;
          Object.entries(errors).forEach(([key, value]) => {
            const errorMessage = `${key.charAt(0).toUpperCase() + key.slice(1)} - ${value}`;
            NotificationManager.error(errorMessage);
          });
        } else {
          NotificationManager.error(t("An error occurred while saving"));
        }
        setIsGenerating(false);
      });

};


const handleChangeSubscription = async (values) => {

    if (!values.plan) {
        NotificationManager.error("No Plan selected")
        return
    } else if (!values.start_date || !values.end_date || !values.next_invoice_date) {
        NotificationManager.error("Please select all the dates")
        return
    }
    const selectedPlan = allPlans?.find(plan => plan.id === values.plan);

    const newPlan = {
        active: true,
        plan_type: "Yearly",
        price: selectedPlan?.yearly_price?.price,
        currency: "SAR",
        start_date: values.start_date,
        end_date: values.end_date,
        next_invoice_date: values.next_invoice_date,
        status: "Active",
        connected_organisation: orgData.id,
        subscription_plan: selectedPlan?.id
    }
    setIsGenerating(true);

    client.patch(`/subscriptions/${orgData?.subscription_detail?.current_subscription?.id}`, newPlan)
      .then(response => {
          setTimeout(() => {
            NotificationManager.success(t('Subscription Changed Successfully.'));
            setIsGenerating(false);
            fetchData()
          }, 1500)
      })
      .catch(error => {
        NotificationManager.error(t("An error occurred while saving"));
        setIsGenerating(false);
      });
};

const handleChangeDates = async (values) => {

    const postValues = {
        start_date : values.start_date,
        next_invoice_date: values.next_invoice_date,
        end_date: values.end_date,
        price: values.price,
    }
    setIsGenerating(true);
    client.patch(`/subscriptions/${orgData?.subscription_detail?.current_subscription?.id}`, postValues)
      .then(response => {
          setTimeout(() => {
            NotificationManager.success(t('Subscription Updated Successfully.'));
            setIsGenerating(false);
            fetchData()
          }, 1500)
      })
      .catch(error => {
        NotificationManager.error(t("An error occurred while saving"));
        setIsGenerating(false);
      });
};

const handleActivateSubscription = async (values) => {
    if (!values.subscription && !values.plan) {
        NotificationManager.error(t("Please select a plan."));
        return;
    }

    const selectedPlan = allPlans?.find(plan => plan.id === values.plan);

    setIsGenerating(true);

    const url = values.plan ? "/subscriptions" : "/activate-subscription";

    const startDate = new Date();
    const endDate = new Date(startDate);
    endDate.setFullYear(startDate.getFullYear() + 1);

    const nextInvoiceDate = new Date(endDate);
    nextInvoiceDate.setMonth(nextInvoiceDate.getMonth() - 1);
    
    const newPlan = {
        active: true,
        plan_type: "Yearly",
        price: selectedPlan?.yearly_price?.price,
        currency: "SAR",
        start_date: startDate.toISOString().split('T')[0],
        end_date: endDate.toISOString().split('T')[0],
        next_invoice_date: nextInvoiceDate.toISOString().split('T')[0],
        status: "Active",
        connected_organisation: orgData.id,
        subscription_plan: selectedPlan?.id
    }

    const postValues = values.plan ? newPlan : values

    client.post(url, postValues)
        .then(response => {
            setTimeout(() => {
                NotificationManager.success(t("Subscription Activated Successfully."));
                setIsGenerating(false);
                fetchData();
            }, 1500);
        })
        .catch(error => {
            NotificationManager.error(t("An error occurred while saving"));
            setIsGenerating(false);
        });
};

const reasonType = [
    {value: "Too Expensive", label: t("Too Expensive")},
    {value: "Not Satisfied", label: t("Not Satisfied")},
    {value: "Changing Application", label: t("Changing Application")},
    {value: "Changing Plan", label: t("Changing Plan")},
    {value: "Other Reason", label: t("Other Reason")},
  ]

  const handleCancelSubscription = async (values) => {

    //setIsSending(true);

    const id = orgData?.subscription_detail?.current_subscription?.id || 0

    if (id === 0) {
      NotificationManager.error(t("The Subscription Cannot be cancelled, please contact the Admin"))
      return
    }

    let endpoint = `/cancel-subscription/${id}`

    client.post(endpoint, values)
      .then(response => {
          setTimeout(() => {
            //setIsSending(false)
            NotificationManager.success(t(response?.data?.detail || "Successfully cancelled the subscription"));
              setTimeout(() => {
                window.location.reload()
              }, 1000);
          }, 1000);
      })
      .catch(error => {
        if (error.response && error.response.data) {
          const errors = error.response.data;
          Object.entries(errors).forEach(([key, value]) => {
            const fieldName = snakeToTitle(key);
            const errorMessage = `${fieldName} - ${value}`;
            NotificationManager.error(errorMessage)
          });
        } else {
          NotificationManager.error(t("An error occurred while saving"));
        }
        //setIsSending(false);
      });
  };

const handleDownload = async (id, invoice_number) => {

    try {
      const response = await client.get(`/core/invoice/${id}/download_invoice`, { responseType: 'blob' });
      const blob = new Blob([response.data], { type: response.data.type });
  
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${invoice_number}.pdf`;
      link.click();
  
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const currentPlan = orgData?.subscription_detail?.current_subscription
//   const latestSubscription = orgData?.subscription_detail?.latest_subscription

  const subPlans = allPlans?.map(plan => ({ value: plan.id, label: plan.name }));

  const closeUpgrade = () => {
    setisOpen(false);
  };


  const goToCustomizeSubscriptionPage = (subscriptionId) => {
    history.push({
      pathname: `/subscriptions/${subscriptionId}`,
    })
  }

  const sendSubscriptionExpiryNotification = async () => {
    setLoading(true)
    const endpoint = `/connected_organisations/${orgData.id}/send-expiry-notification`;
    client.get(endpoint)
        .then(response => {
            NotificationManager.success(t(response?.data?.detail || "Successfully sent expiry notification"));
            setLoading(false)
        })
        .catch(error => {
            NotificationManager.error(t(error?.response?.data?.detail || "An error occurred while sending expiry notification"));
            setLoading(false)
        });
  }

  return (
    <Page title={"Organisation Details"} className="inv-table inv-tabs nw-list">
        <GetBack styleClass="my-2"></GetBack>
      
        {orgData &&
        <> 
        <Row className="pt-4">
            <Col className="col-auto">
                <img width="110" src="https://e7.pngegg.com/pngimages/115/523/png-clipart-product-design-brand-logo-font-demo-text-orange.png"/>
            </Col>
            <Col md={10}>
                <h3 className="text-success">{orgData.name}</h3>
                <Row>
                    <Col className="col-auto">
                        <h6>Subscriber User : <span className="text-success">{orgData.subscriber_user?.email} ,</span></h6>
                        <h6>Contact Name : <span className="text-success">{orgData.subscriber_user?.full_name} ,</span></h6>
                        <h6>Company Name : <span className="text-success">{orgData.company_detail?.company_name} , {orgData.company_detail?.company_country}.</span></h6>
                    </Col>
                    <Col className="col-auto">
                        <h6>Invoice Paid : <span className="text-success">{orgData.invoices?.paid_count}</span></h6>
                        <h6>Invoice Unpaid : <span className="text-success">{orgData.invoices?.unpaid_count}</span></h6>
                        <h6>Invoice Cancelled : <span className="text-success">{orgData.invoices?.cancelled_count}</span></h6>
                    </Col>
                    <Col className="col-auto">
                        <h6>Xero Status : <span className="text-success">{orgData.status}</span></h6>
                        <h6>Subscription Status : <span className="text-success">{currentPlan?.status}</span></h6>
                        <h6>Total User : <span className="text-success">{orgData.total_user}</span></h6>
                    </Col>
                </Row>
            </Col>
        </Row>
        <Row className="pt-4">
            <Col>
                <Nav tabs className="nw-tabs2 inv-tabs">
                    <div style={{cursor:"pointer"}} onClick={() => toggleTab('1')} className={activeTab === '1' ? `active-tab`: ``}>
                        <Trans>Subscription</Trans> 
                    </div>
                    <div style={{cursor:"pointer"}} onClick={() => toggleTab('2')} className={activeTab === '2' ? `active-tab`: ``}>
                        <Trans>Invoices</Trans> 
                    </div>
                    <div style={{cursor:"pointer"}} onClick={() => toggleTab('3')} className={activeTab === '3' ? `active-tab`: ``}>
                        <Trans>Company Info</Trans> 
                    </div>
                    <div style={{cursor:"pointer"}} onClick={() => toggleTab('4')} className={activeTab === '4' ? `active-tab`: ``}>
                        <Trans>Users</Trans> 
                    </div>
                    <div style={{cursor:"pointer"}} onClick={() => toggleTab('5')} className={activeTab === '5' ? `active-tab`: ``}>
                        <Trans>Client Id</Trans> 
                    </div>
                    <div style={{cursor:"pointer"}} onClick={() => toggleTab('6')} className={activeTab === '6' ? `active-tab`: ``}>
                        <Trans>Manage Subscription</Trans> 
                    </div>
                    {/* <NavItem>
                        <NavLink className={classnames({ active: activeTab === '1' })} onClick={() => toggleTab('1')}>
                            <Trans>Subscription</Trans>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === '2' })} onClick={() => toggleTab('2')}>
                        <Trans>Invoices</Trans>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === '3' })} onClick={() => toggleTab('3')}>
                        <Trans>Company Info</Trans>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === '4' })} onClick={() => toggleTab('4')}>
                        <Trans>Users</Trans>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === '5' })} onClick={() => toggleTab('5')}>
                        <Trans>Client Id</Trans>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === '6' })} onClick={() => toggleTab('6')}>
                            <Trans>Manage Subscription</Trans>
                        </NavLink>
                    </NavItem> */}
                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <Row className="pt-4 right">
                            <Col>
                                <h4 className="pt-3"><Trans>Plan Name:</Trans> {currentPlan?.subscription_plan_name}</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <p><Trans>Plan Type:</Trans> {currentPlan?.plan_type}</p>
                                {currentPlan?.package_price?.is_vat_included ? (
                                    <p><Trans>Vat Included Price:</Trans> {currentPlan?.package_price?.price}</p>
                                ) : (
                                    <p><Trans>Vat Excluded Price:</Trans> {currentPlan?.package_price?.price}</p>
                                )}
                            </Col>
                            <Col>
                                <p><Trans>Start Date:</Trans> {currentPlan?.start_date}</p>
                                <p><Trans>End Date:</Trans> {currentPlan?.end_date}</p>
                            </Col>
                            <Col>
                                
                                <p><Trans>Next Billing Date:</Trans> {currentPlan?.next_invoice_date}</p>
                                <p><Trans>Status:</Trans> {currentPlan?.status}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card className="p-4">
                                    <h4><Trans>Modules</Trans></h4>
                                    {moduleData?.map((i, idx)  => ( <>
                                    <p>{idx + 1}. {i.content_object_data.name}</p>
                                    </>))}
                                </Card>
                            </Col>
                            <Col>
                                <Card className="p-4">
                                    <h4><Trans>Applications</Trans></h4>
                                    {appData?.map((i, idx)  => ( <>
                                    <p>{idx + 1}. {i.content_object_data.name}</p>
                                    </>))}
                                </Card>
                            </Col>
                            <Col>
                                <Card className="p-4">
                                    <h4><Trans>Languages</Trans></h4>
                                    {langData?.map((i, idx)  => ( <>
                                    <p>{idx + 1}. {i.content_object_data.name}</p>
                                    </>))}
                                </Card>
                            </Col>
                        </Row>
                    </TabPane>

                    <TabPane tabId="2">
                        <Row>
                            <Col>
                                <h4 className="pt-3"><Trans>Invoice List</Trans></h4>
                                <Table size="sm" className="small">
                                    <thead>
                                        <tr>
                                            <th className="text-left">
                                            <Trans>Invoice Number</Trans>
                                            </th>
                                            <th sortby="name">
                                            <Trans>Issue Date</Trans>
                                            </th>
                                            <th sortby="name">
                                            <Trans>Sub Total</Trans>
                                            </th>
                                            <th sortby="name">
                                            <Trans>Vat Amount</Trans>
                                            </th>
                                            <th sortby="name">
                                            <Trans>Total Amount</Trans>
                                            </th>
                                            <th sortby="name">
                                                <Trans>Currency</Trans>
                                            </th>
                                            <th sortby="name" className="text-right">
                                            <Trans>Status</Trans>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orgData?.invoices?.invoices?.map((i) => (
                                        <tr key={i.id}>
                                            <td className="text-left">{i.invoice_number}</td>
                                            <td>{i.issue_date}</td>
                                            <td>{i.sub_total}</td>
                                            <td>{i.vat_amount}</td>
                                            <td>{i.total_amount}</td>
                                            <td>{i.currency}</td>
                                            <td className="text-right"> 
                                            {i.status && <span style={getOutlineStyle(status_map[i.status].color)}>{status_map[i.status].text}</span>}
                                            </td>
                                            <td className="text-right">
                                                <Button color="primary" size="sm" onClick={() => history.push(`/core/invoice/${i.subscription}`)}><Trans>View</Trans></Button>
                                                {i.status==="Paid" && 
                                                    <Button color="primary" size="sm" onClick={() => handleDownload(i.subscription, i.invoice_number)}><i className="fa fa-download"/></Button>
                                                }
                                            </td>
                                        </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId="3">
                        <Row>
                            <Col>
                                <h4 className="pt-3">Company Info</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <p><Trans>Name</Trans>: <b>{orgData.company_detail?.company_name}</b></p>
                                <p><Trans>Email</Trans>: <b>{orgData.company_detail?.company_email}</b></p>
                                <p><Trans>Tax Number</Trans>: <b>{orgData.company_detail?.company_tax_number}</b></p>
                                <p><Trans>Country</Trans>: <b>{orgData.company_detail?.company_country}</b></p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <HistoryAndNotes
                                    item={orgData}
                                    contentType={'connectedorganisation'}
                                    t={t}
                                    hideNoteBtn={true}
                                />
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId="4">
                        <Row>
                            <Col>
                                <h4 className="pt-4">User List</h4>
                                <Table size="sm" className="small">
                                    <thead>
                                        <tr>
                                            <th className="text-left"><Trans>ID </Trans></th>
                                            <th className="text-center"><Trans>Name</Trans></th>
                                            <th className="text-center"><Trans>Email</Trans></th>
                                            <th className="text-center"><Trans>Role</Trans></th>
                                            <th className="text-center"><Trans>Group</Trans></th>
                                            <th className="text-center"><Trans>Active</Trans></th>
                                            <th className="text-center"><Trans>Suspend</Trans></th>
                                            <th className="text-center"><Trans>Joined</Trans></th>
                                            <th className="text-right"><Trans>Last Login</Trans></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orgData?.user?.map((i) => (
                                        <tr key={i.id}>
                                            <td className="text-left">{i.id}</td>
                                            <td><Link to={`/${i.role === "Subscriber" ? "subscribers" : "users"}/${i.id}`}>{i.full_name}</Link></td>
                                            <td className="text-center">{i.email}</td>
                                            <td className="text-center">{i.role}</td>
                                            <td className="text-center">{i.group_names}</td>
                                            <td className="text-center">
                                            {i.is_active ? (
                                                    <span className="fa fa-check-circle text-success" />
                                                ) : (
                                                    <span className="fa fa-times-circle text-danger" />
                                                )}
                                            </td>
                                            <td className="text-center">
                                            {i.suspend ? (
                                                    <span className="fa fa-check-circle text-success text-right" />
                                                ) : (
                                                    <span className="fa fa-times-circle text-danger text-right" />
                                                )}
                                            </td>
                                            <td className="text-center">{formatDateTime(i.date_joined)}</td>
                                            <td className="text-right">{formatDateTime(i.last_login)}</td>
                                        </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId="5">
                        <Row className="pt-4">
                            <Col>
                                <h4><Trans>Client Code</Trans></h4>
                            </Col>
                        </Row>
                        <Row className="pt-4">
                            {orgData.client_id ? (
                                <>
                                    <Col>
                                        <KeyField label="Client ID" value={orgData.client_id}/>
                                    </Col>
                                </>
                            ) : (
                                <>
                                    {/* If client_id is not present, hide the input */}
                                    <LocalForm onSubmit={handlePost}>
                                    <Col>
                                        <FormGroup label="Organisation ID *" model=".id">
                                            <Control.text disabled defaultValue={orgData?.id} model=".id" />
                                        </FormGroup>
                                        <FormGroup label="Organisation Name *" model=".name">
                                            <Control.text model=".name" disabled defaultValue={orgData?.name} />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        {!isGenerating ? 
                                        <Button className="mx-0 my-3 btn btn-success w-100"><Trans>Generate Client Id</Trans></Button>
                                        :
                                        <Button disabled className="mx-0 my-3 btn btn-success w-100"><Trans>Generating</Trans></Button>
                                    }
                                    </Col>
                                    </LocalForm>
                                </>
                            )}
                        </Row>
                    </TabPane>
                    <TabPane tabId="6">
                        <Row className="pt-4">
                            <Col>
                                <h4><Trans>Manage Subscription</Trans></h4>
                            </Col>
                        </Row>
                        <Row className="pt-4">
                            {currentPlan?.status == "Active" ? (
                                <>
                                    <LocalForm onSubmit={handleCancelSubscription}>
                                    <Col>
                                        <p><Trans>Current Subscription Plan {currentPlan?.subscription_plan_name} is <span className="text-success">{currentPlan?.status}</span></Trans> </p>
                                        <FormGroup label={t("Reason*")} addControlClass={false}>
                                            <Control.text style={{ backgroundColor: '#F4F7FE' }}
                                                model=".cancellation_reason"
                                                component={Select}
                                                options={reasonType}
                                                clearable={false}
                                                simpleValue
                                                placeholder={('Select...')}
                                            />
                                        </FormGroup>
                                        <FormGroup label={t("Note*")}>
                                        <Control.textarea
                                            model=".cancellation_note"
                                            className="border"
                                        />
                                        </FormGroup>
                                        
                                    </Col>
                                    <Col>
                                        <div className="d-flex justify-content-center flex-column">
                                            <Button className="mx-0 my-2 btn btn-danger"><Trans>Cancel Subscription Plan</Trans></Button>
                                            <Button className="mx-0 my-2 btn btn-success" onClick={() => setisOpen(!isUpgrade)}><Trans>Change Subscription Plan</Trans></Button>
                                            <Button className="mx-0 my-2 btn btn-success" onClick={() => goToCustomizeSubscriptionPage(currentPlan?.id)}><Trans>Update Subscription</Trans></Button>
                                        </div>
                                    </Col>
                                    </LocalForm>
                                </>
                            ) : (
                                <>
                                    <LocalForm onSubmit={handleActivateSubscription}>
                                        <Col>
                                          {currentPlan?.id ?
                                            <>
                                                <p><Trans>Current Subscription Plan {currentPlan?.subscription_plan_name} is <span className="text-warning">{currentPlan?.status}</span></Trans></p>
                                                <FormGroup label="subscription *" model=".subscription">
                                                    <Control.text  model=".subscription" disabled defaultValue={currentPlan?.id}/>
                                                </FormGroup>
                                                <FormGroup label="Force *" model=".force" hidden>
                                                    <Control.text model=".force" defaultValue={true} disabled/>
                                                </FormGroup>
                                            </>
                                            :
                                            <>
                                            <FormGroup label="Subscription Plan" className="my-2" addControlClass={false}>
                                                <Control.text style={{ backgroundColor: '#F4F7FE' }}
                                                  model=".plan"
                                                  component={Select}
                                                  options={subPlans}
                                                  simpleValue
                                                  clearable={false}
                                                  placeholder={('Select...')}
                                                />
                                            </FormGroup>
                                            </>
                                          }
                                            
                                        </Col>
                                        <Col>
                                            <div className="d-flex justify-content-center flex-column">
                                                
                                                {isGenerating ? 
                                                    <Button disabled className="mx-0 my-3 btn btn-success"><i className="fa fa-spinner fa-spin"/> <Trans>Activating</Trans></Button>
                                                    :
                                                    <Button className="mx-0 my-3 btn btn-success"><Trans>Activate Subscription</Trans></Button>
                                                }
                                                {
                                                    currentPlan?.status == "Expired" &&
                                                    <Button className="mx-0 my-2 btn btn-success" onClick={() => sendSubscriptionExpiryNotification()} disabled={loading}>{loading && <i className="fa fa-spinner fa-spin"/>} <Trans>Send Subscription Expiry Notification</Trans></Button>
                                                }

                                            </div>
                                        </Col>
                                    </LocalForm>
                                </>
                            )}
                            {currentPlan?.id && 
                                <LocalForm onSubmit={handleChangeDates} initialState={currentPlan}>
                                    <Col>
                                        <p><Trans>Subscription Details</Trans></p>
                                        <FormGroup label="Start Date" className="my-2">
                                               <DatePicker model=".start_date" />
                                        </FormGroup>
                                        <FormGroup label="End Date" className="my-2">
                                               <DatePicker model=".end_date" />
                                        </FormGroup>
                                        <FormGroup label="Next Billing Date" className="my-2">
                                               <DatePicker model=".next_invoice_date" />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                    {isGenerating ? 
                                        <Button disabled className="mx-0 my-3 btn btn-success w-100"><i className="fa fa-spinner fa-spin"/> <Trans>Changing</Trans></Button>
                                        :
                                        <Button className="mx-0 my-3 btn btn-success w-100"><Trans>Change Dates</Trans></Button>
                                    }
                                    </Col>
                                </LocalForm>
                            }
                            
                        </Row>
                        <Modal isOpen={isUpgrade} toggle={closeUpgrade}>
                            <ModalHeader>
                            <div><Trans>Upgrade the Plan</Trans></div>
                            </ModalHeader>
                            <ModalBody>
                            <LocalForm onSubmit={handleChangeSubscription}>
                                    <Col>
                                        <p><Trans>Select a Plan to Upgrade</Trans></p>
                                        <FormGroup label="Subscription Plan" className="my-2" addControlClass={false}>
                                                <Control.text style={{ backgroundColor: '#F4F7FE' }}
                                                  model=".plan"
                                                  component={Select}
                                                  options={subPlans}
                                                  simpleValue
                                                  clearable={false}
                                                  placeholder={('Select...')}
                                                />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <p><Trans>Subscription Details</Trans></p>
                                        <FormGroup label="Start Date" className="my-2">
                                               <DatePicker model=".start_date" />
                                        </FormGroup>
                                        <FormGroup label="End Date" className="my-2">
                                               <DatePicker model=".end_date" />
                                        </FormGroup>
                                        <FormGroup label="Next Billing Date" className="my-2">
                                               <DatePicker model=".next_invoice_date" />
                                        </FormGroup>
                                    </Col>
                                    {isGenerating ? 
                                        <Button disabled className="mx-0 my-3 btn btn-success w-100"><i className="fa fa-spinner fa-spin"/> <Trans>Changing</Trans></Button>
                                        :
                                        <Button className="mx-0 my-3 btn btn-success w-100"><Trans>Change Subscription</Trans></Button>
                                    }
                                </LocalForm>
                            </ModalBody>
                            <ModalFooter>
                            <Button onClick={() => closeUpgrade()}>Close</Button>
                            </ModalFooter>
                        </Modal>
                    </TabPane>
                </TabContent>
            </Col>
        </Row>
        </>
        }

    </Page>
  );
};

export default OrganisationDetail;
